import useSWR from 'swr'
import type { Manager, PipelineId } from '@ludus/core'
import { listManagers } from '@/lib/api/managers.ts'
import type { PipelineApiError } from '@/lib/api/pipelines.ts'

export const MANAGERS_KEY = ['managers'] as const

/**
 * The tenant's managers, one cache entry for every consumer. A card's owner is
 * looked up here: a source's assignee is seated as a manager without joining
 * the pipeline (#129), so the participating slice alone would name them by id.
 */
export function useManagers() {
  const { data, error, isLoading } = useSWR(MANAGERS_KEY, () => listManagers())
  return { managers: data, error: error as PipelineApiError | undefined, isLoading }
}

/** The same predicate as the engine's `participatingManagers()`. */
export function participantsOf(managers: Manager[], pipelineId: PipelineId): Manager[] {
  return managers.filter((m) => m.isActive && m.pipelineIds.includes(pipelineId))
}
